import type { ColumnsType } from 'antd/es/table';

export const sequencesTableOptions: ColumnsType<any> = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Delivery Url',
    dataIndex: 'deliveryUrl',
    key: 'deliveryUrl',
  },
  {
    title: 'Unified Api',
    dataIndex: 'unifiedApi',
    key: 'unifiedApi',
  },
  {
    title: 'Count events',
    dataIndex: 'events',
    key: 'id',
    render: (events) => events.length,
  },
];
